/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateEnvironmentForm,
  CreateEnvironmentForm$Outbound,
  CreateEnvironmentForm$outboundSchema,
} from "../components/createenvironmentform.js";

export type CreateEnvironmentSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type CreateEnvironmentRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  createEnvironmentForm: CreateEnvironmentForm;
};

/** @internal */
export type CreateEnvironmentSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const CreateEnvironmentSecurity$outboundSchema: z.ZodMiniType<
  CreateEnvironmentSecurity$Outbound,
  CreateEnvironmentSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createEnvironmentSecurityToJSON(
  createEnvironmentSecurity: CreateEnvironmentSecurity,
): string {
  return JSON.stringify(
    CreateEnvironmentSecurity$outboundSchema.parse(createEnvironmentSecurity),
  );
}

/** @internal */
export type CreateEnvironmentRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  CreateEnvironmentForm: CreateEnvironmentForm$Outbound;
};

/** @internal */
export const CreateEnvironmentRequest$outboundSchema: z.ZodMiniType<
  CreateEnvironmentRequest$Outbound,
  CreateEnvironmentRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    createEnvironmentForm: CreateEnvironmentForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      createEnvironmentForm: "CreateEnvironmentForm",
    });
  }),
);

export function createEnvironmentRequestToJSON(
  createEnvironmentRequest: CreateEnvironmentRequest,
): string {
  return JSON.stringify(
    CreateEnvironmentRequest$outboundSchema.parse(createEnvironmentRequest),
  );
}
